(function () {
  "use strict";

  // SearchSpring URL/UI field → Algolia facet attribute
  var SS_TO_ALGOLIA_FACET = {
    product_type: "product_type",
    ss_product_type: "product_type",
    brand: "vendor",
    vendor: "vendor",
    tags: "tags",
    price_range: "price_range",
    ss_price: "price",
    mfield_new_my_fields_brand_name: "meta.new_my_fields.brand_name",
    variant_mfield_new_my_fields_filter_color:
      "meta.new_my_fields.filter_color",
    mfield_new_my_fields_filter_color: "meta.new_my_fields.filter_color",
    variant_mfield_new_my_fields_lead_time: "meta.new_my_fields.lead_time",
    mfield_new_my_fields_lead_time: "meta.new_my_fields.lead_time",
    mfield_new_my_fields_sub_category: "meta.new_my_fields.sub_category",
    mfield_new_my_fields_main_category: "meta.new_my_fields.main_category",
    mfield_new_my_fields_shipping_rate: "meta.new_my_fields.shipping_rate",
    variant_mfield_custom_sale_bucket: "meta.custom.sale_bucket",
    mfield_custom_sale_bucket: "meta.custom.sale_bucket",
    mfield_filters_feature: "meta.filters.feature",
    filters_feature: "meta.filters.feature",
    ss_available: "inventory_available",
    inventory_available: "inventory_available",
    collection_handle: "collections",
    mfield_custom_length_rounded_ft_filter:
      "meta.custom.length_rounded_ft_filter_",
    mfield_custom_width_rounded_ft_filter:
      "meta.custom.width_rounded_ft_filter_",
    // Legacy keys without trailing underscore (Explorer may still show either)
    mfield_custom_length_rounded_ft_filter_:
      "meta.custom.length_rounded_ft_filter_",
    mfield_custom_width_rounded_ft_filter_:
      "meta.custom.width_rounded_ft_filter_",
    ss_all_width_filter: "meta.custom.all_width_filter",
    variant_mfield_custom_rug_size_bucket_filter:
      "meta.custom.rug_size_bucket_filter",
    mfield_custom_rug_size_bucket_filter: "meta.custom.rug_size_bucket_filter",
    variant_mfield_custom_width_filter: "meta.custom.width_filter",
    mfield_custom_width_filter: "meta.custom.width_filter",
    mfield_custom_primary_style: "meta.custom.primary_style",
    mfield_custom_rug_pattern: "meta.custom.rug_pattern",
    variant_mfield_custom_material_filter: "meta.custom.material_filter",
    mfield_custom_material_filter: "meta.custom.material_filter",
    variant_mfield_custom_gemstone_filter: "meta.custom.gemstone_filter",
    mfield_custom_gemstone_filter: "meta.custom.gemstone_filter",
    variant_mfield_custom_jewelry_metal_filter:
      "meta.custom.jewelry_metal_filter",
    mfield_custom_jewelry_metal_filter: "meta.custom.jewelry_metal_filter",
    variant_mfield_custom_jewelry_ring_type: "meta.custom.jewelry_ring_type",
    mfield_custom_jewelry_ring_type: "meta.custom.jewelry_ring_type",
    variant_mfield_custom_variant_length_rounded_ft_filter:
      "meta.custom.variant_length_rounded_ft_filter_",
    mfield_custom_variant_length_rounded_ft_filter:
      "meta.custom.variant_length_rounded_ft_filter_",
    variant_mfield_custom_variant_width_rounded_ft_filter:
      "meta.custom.variant_width_rounded_ft_filter_",
    mfield_custom_variant_width_rounded_ft_filter:
      "meta.custom.variant_width_rounded_ft_filter_",
  };

  // Preferred Algolia → SS field for UI renderers (color swatches, size buckets, etc.)
  var ALGOLIA_TO_SS_FACET_PREFERRED = {
    product_type: "ss_product_type",
    vendor: "vendor",
    tags: "tags",
    price_range: "price_range",
    price: "ss_price",
    "meta.new_my_fields.brand_name": "mfield_new_my_fields_brand_name",
    "meta.new_my_fields.filter_color":
      "variant_mfield_new_my_fields_filter_color",
    "meta.new_my_fields.lead_time": "variant_mfield_new_my_fields_lead_time",
    "meta.new_my_fields.sub_category": "mfield_new_my_fields_sub_category",
    "meta.new_my_fields.main_category": "mfield_new_my_fields_main_category",
    "meta.new_my_fields.shipping_rate": "mfield_new_my_fields_shipping_rate",
    "meta.custom.sale_bucket": "variant_mfield_custom_sale_bucket",
    "meta.filters.feature": "mfield_filters_feature",
    inventory_available: "ss_available",
    collections: "collection_handle",
    "meta.custom.length_rounded_ft_filter_":
      "mfield_custom_length_rounded_ft_filter",
    "meta.custom.width_rounded_ft_filter_":
      "mfield_custom_width_rounded_ft_filter",
    "meta.custom.length_rounded_ft_filter":
      "mfield_custom_length_rounded_ft_filter",
    "meta.custom.width_rounded_ft_filter":
      "mfield_custom_width_rounded_ft_filter",
    "meta.custom.all_width_filter": "ss_all_width_filter",
    "meta.custom.rug_size_bucket_filter":
      "variant_mfield_custom_rug_size_bucket_filter",
    "meta.custom.width_filter": "variant_mfield_custom_width_filter",
    "meta.custom.primary_style": "mfield_custom_primary_style",
    "meta.custom.rug_pattern": "mfield_custom_rug_pattern",
    "meta.custom.material_filter": "variant_mfield_custom_material_filter",
    "meta.custom.gemstone_filter": "variant_mfield_custom_gemstone_filter",
    "meta.custom.jewelry_metal_filter":
      "variant_mfield_custom_jewelry_metal_filter",
    "meta.custom.jewelry_ring_type": "variant_mfield_custom_jewelry_ring_type",
    "meta.custom.variant_length_rounded_ft_filter_":
      "mfield_custom_variant_length_rounded_ft_filter",
    "meta.custom.variant_width_rounded_ft_filter_":
      "mfield_custom_variant_width_rounded_ft_filter",
  };

  var ALGOLIA_TO_SS_FACET = {};
  Object.keys(ALGOLIA_TO_SS_FACET_PREFERRED).forEach(function (alg) {
    ALGOLIA_TO_SS_FACET[alg] = ALGOLIA_TO_SS_FACET_PREFERRED[alg];
  });
  // Fill any forward-map attrs missing from preferred reverse
  Object.keys(SS_TO_ALGOLIA_FACET).forEach(function (ss) {
    var alg = SS_TO_ALGOLIA_FACET[ss];
    if (!ALGOLIA_TO_SS_FACET[alg]) ALGOLIA_TO_SS_FACET[alg] = ss;
  });

  var FACET_LABELS = {
    product_type: "Product Type",
    vendor: "Vendor",
    tags: "Tags",
    price_range: "Price Range",
    price: "Price",
    "meta.new_my_fields.brand_name": "Brand",
    "meta.new_my_fields.filter_color": "Color",
    "meta.new_my_fields.lead_time": "Delivery Time",
    "meta.new_my_fields.sub_category": "Sub Category",
    "meta.new_my_fields.main_category": "Category",
    "meta.new_my_fields.shipping_rate": "Shipping",
    "meta.custom.sale_bucket": "% Off",
    "meta.custom.rug_size_bucket_filter": "Standard Sizes",
    "meta.custom.width_filter": "Width",
    "meta.custom.all_width_filter": "Width",
    "meta.custom.width_rounded_ft_filter": "Width (ft)",
    "meta.custom.length_rounded_ft_filter": "Length (ft)",
    "meta.custom.width_rounded_ft_filter_": "Width (ft)",
    "meta.custom.length_rounded_ft_filter_": "Length (ft)",
    "meta.custom.primary_style": "Style",
    "meta.custom.rug_pattern": "Pattern",
    "meta.filters.feature": "Feature",
    "meta.custom.material_filter": "Material",
    "meta.custom.gemstone_filter": "Gemstone",
    "meta.custom.jewelry_metal_filter": "Metal",
    "meta.custom.jewelry_ring_type": "Ring Type",
    "meta.custom.variant_length_rounded_ft_filter_": "Length (ft)",
    "meta.custom.variant_width_rounded_ft_filter_": "Width (ft)",
    collections: "Collection",
  };

  var RANGE_FIELDS = [
    "ss_price",
    "mfield_custom_length_rounded_ft_filter",
    "mfield_custom_width_rounded_ft_filter",
    "ss_all_width_filter",
  ];

  function isRangeField(field) {
    return RANGE_FIELDS.indexOf(field) !== -1;
  }

  /** Shopify list metafield facet values often arrive as '["Brown"]' — normalize for UI/URL. */
  function unwrapFacetValue(val) {
    if (val == null) return "";
    var str = String(val).trim();
    if (!str) return "";
    if (str.charAt(0) === "[") {
      try {
        var parsed = JSON.parse(str);
        if (Array.isArray(parsed) && parsed.length) {
          return String(parsed[0]).trim();
        }
        if (typeof parsed === "string") return parsed.trim();
      } catch (e) {
        /* keep str */
      }
    }
    if (str.charAt(0) === '"' && str.charAt(str.length - 1) === '"') {
      try {
        return String(JSON.parse(str)).trim();
      } catch (e2) {
        /* keep str */
      }
    }
    return str;
  }

  /**
   * Match both clean and JSON-encoded facet values in the index
   * (some metafields still indexed as '["Brown"]').
   */
  function facetValueMatchForms(val) {
    var clean = unwrapFacetValue(val);
    var forms = [];
    function pushUnique(v) {
      if (v == null || v === "") return;
      var s = String(v);
      if (forms.indexOf(s) === -1) forms.push(s);
    }
    pushUnique(clean);
    pushUnique(val);
    if (clean) pushUnique(JSON.stringify([clean]));
    return forms.length ? forms : [String(val)];
  }

  function getSortIndexName(sortParam, baseIndex) {
    if (!sortParam) return baseIndex;
    var map = {};
    map["sort.ss_boost=desc"] = baseIndex;
    map["sort.ss_price=asc"] = baseIndex + "_price_asc";
    map["sort.ss_price=desc"] = baseIndex + "_price_desc";
    map["sort.ga_unique_purchases=desc"] =
      baseIndex + "_recently_ordered_count_desc";
    map["sort.mfield_analytics_product_revenue_ytd=desc"] =
      baseIndex + "_recently_ordered_count_desc";
    map["sort.ss_pct_off=desc"] = baseIndex + "_price_ratio_asc";
    map["sort.published_at=desc"] = baseIndex + "_published_at_desc";
    map["sort.variant_mfield_custom_item_revenue=asc"] = baseIndex;
    return map[sortParam] || baseIndex;
  }

  function getDefaultSortOptions() {
    return {
      options: [
        { field: "ss_boost", direction: "desc", label: "Featured" },
        { field: "published_at", direction: "desc", label: "New" },
        { field: "ss_price", direction: "asc", label: "Price: Low to High" },
        { field: "ss_price", direction: "desc", label: "Price: High to Low" },
        {
          field: "ga_unique_purchases",
          direction: "desc",
          label: "Best Selling",
        },
        { field: "ss_pct_off", direction: "desc", label: "Percent: High to Low" },
      ],
    };
  }

  /** Product-reference metafield → gid://shopify/Product/... for PLP Add Sample */
  function normalizeProductReferenceGid(value) {
    if (value == null || value === "") return "";

    if (typeof value === "object") {
      return normalizeProductReferenceGid(value.id || value._id || "");
    }

    var str = String(value).trim();
    if (!str) return "";

    if (str.indexOf("gid://shopify/Product/") === 0) return str;

    var numeric = str.replace(/\D/g, "");
    if (numeric) return "gid://shopify/Product/" + numeric;

    return "";
  }

  /**
   * Insights requires queryID as a 32-char hex string (or message_*).
   * Strip a mistaken "queryID:" prefix that causes HTTP 422 in Events Debugger.
   */
  function normalizeQueryID(raw) {
    if (raw == null || raw === "") return "";
    var id = String(raw).trim();
    if (/^queryID:/i.test(id)) {
      id = id.replace(/^queryID:/i, "").trim();
    }
    return id;
  }

  /**
   * Search-only: if a query token appears on this hit's color/variant fields,
   * prefer the Algolia variant image over the seeded PLP gallery photo.
   */
  var SEARCH_TYPE_TOKENS = {
    sofa: 1,
    sofas: 1,
    chair: 1,
    chairs: 1,
    table: 1,
    tables: 1,
    rug: 1,
    rugs: 1,
    pillow: 1,
    pillows: 1,
    lamp: 1,
    lamps: 1,
    bed: 1,
    beds: 1,
    ottoman: 1,
    ottomans: 1,
    sectional: 1,
    sectionals: 1,
    stool: 1,
    stools: 1,
    bench: 1,
    benches: 1,
    desk: 1,
    desks: 1,
    furniture: 1,
    throw: 1,
    throws: 1,
    sleeper: 1,
  };

  function queryMatchesHitColor(hit, query, nm) {
    if (!query || !hit) return false;
    var tokens = String(query)
      .toLowerCase()
      .split(/[\s,+]+/)
      .map(function (word) {
        return word.replace(/[^a-z0-9-]/g, "").trim();
      })
      .filter(function (word) {
        return word.length >= 3 && !SEARCH_TYPE_TOKENS[word];
      });
    if (!tokens.length) return false;

    var colorBits = [
      hit.variant_title,
      unwrapListText(nm && nm.filter_color),
      unwrapListText(hit.mfield_new_my_fields_filter_color),
      hit.option1,
      hit.option2,
      hit.option3,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    if (!colorBits) return false;

    return tokens.some(function (token) {
      var escaped = token.replace(/[.*+?^${}()|[\]\\-]/g, "\\$&");
      return new RegExp("(^|[^a-z0-9])" + escaped + "([^a-z0-9]|$)", "i").test(
        colorBits
      );
    });
  }

  function collectColorLabels(value) {
    var labels = [];
    function walk(entry) {
      if (entry == null || entry === "") return;
      if (Array.isArray(entry)) {
        entry.forEach(walk);
        return;
      }
      var str = String(entry).trim().replace(/&quot;/g, '"');
      if (!str) return;
      if (str.charAt(0) === "[") {
        try {
          var parsed = JSON.parse(str);
          if (Array.isArray(parsed)) {
            parsed.forEach(walk);
            return;
          }
        } catch (e) {
          /* keep str */
        }
      }
      if (str.indexOf("|") !== -1) {
        str.split("|").forEach(function (part) {
          walk(part);
        });
        return;
      }
      var normalized = unwrapFacetValue(str).toLowerCase().replace(/\s+/g, " ").trim();
      if (normalized) labels.push(normalized);
    }
    walk(value);
    return labels;
  }

  function hitMatchesSelectedColors(hit, nm, selectedNorms) {
    if (!selectedNorms || !selectedNorms.length) return false;
    var labels = collectColorLabels(nm && nm.filter_color).concat(
      collectColorLabels(hit && hit.mfield_new_my_fields_filter_color)
    );
    for (var i = 0; i < labels.length; i++) {
      if (selectedNorms.indexOf(labels[i]) !== -1) return true;
    }
    return false;
  }

  function normalizeSliderImageUrls(raw) {
    var list = raw;
    if (typeof raw === "string") {
      var trimmed = raw.trim();
      if (!trimmed) return [];
      if (trimmed.charAt(0) === "[") {
        try {
          list = JSON.parse(trimmed);
        } catch (e) {
          list = trimmed.split(",");
        }
      } else {
        list = trimmed.split(",");
      }
    }
    if (!Array.isArray(list)) return [];
    var out = [];
    for (var i = 0; i < list.length && out.length < 3; i++) {
      var url = String(list[i] == null ? "" : list[i]).trim();
      if (!url || /^gid:\/\//.test(url)) continue;
      if (!/^https?:\/\//.test(url) && url.indexOf("//") !== 0) continue;
      out.push(url);
    }
    return out;
  }

  function normalizeHit(hit, query, selectedColorNorms) {
    var meta = hit.meta || {};
    var cm = meta.custom || {};
    var nm = meta.new_my_fields || {};
    var am = meta.analytics || {};
    var pm = meta.product || {};

    // Parse metafield once → SS shapes + furniture color list + grid caches
    var plpMapped = mapPlpVariantsToSearchSpring(hit, cm);
    // SearchSpring ss_image_hover = 2nd product MediaImage (not featured/product_image)
    var hoverMapped = resolveSsImageHover(hit, cm);
    // PLP card main image: seeded product gallery[0] (not Algolia variant featured image)
    var plpMainImage = String(
      cm.algolia_plp_main_image || hit.mfield_custom_algolia_plp_main_image || ""
    ).trim();
    var variantImage = String(hit.image || hit.product_image || "").trim();
    var colorMatchedFromFilter = hitMatchesSelectedColors(
      hit,
      nm,
      selectedColorNorms
    );
    var colorMatchedFromQuery = queryMatchesHitColor(hit, query, nm);
    var useVariantImage = colorMatchedFromFilter || colorMatchedFromQuery;
    var cardMainImage = useVariantImage
      ? variantImage || plpMainImage
      : plpMainImage || variantImage;

    return {
      name: hit.title || "",
      title: hit.title || "",
      url: hit.handle ? "/products/" + hit.handle : "#",
      handle: hit.handle || "",
      price: String(hit.price != null ? hit.price : ""),
      msrp: String(hit.compare_at_price != null ? hit.compare_at_price : ""),
      variant_compare_at_price: String(
        hit.compare_at_price != null ? hit.compare_at_price : ""
      ),
      variant_price: String(hit.price != null ? hit.price : ""),
      product_type: hit.product_type || "",
      sku: hit.sku || "",
      vendor: hit.vendor || "",
      brand: nm.brand_name || hit.vendor || "",
      tags: hit.tags || [],

      uid: String(hit.objectID || ""),
      ss_id: String(hit.objectID || ""),
      variant_id: String(hit.objectID || ""),
      variant_product_id: String(hit.id || hit.product_id || ""),
      id: String(hit.id || hit.product_id || ""),
      objectID: hit.objectID,

      thumbnailImageUrl: cardMainImage,
      imageUrl: useVariantImage
        ? cardMainImage
        : plpMainImage || hit.product_image || hit.image || "",
      ss_image: cardMainImage,
      ss_image_hover: hoverMapped.ss_image_hover,
      _plpHoverPendingGid: hoverMapped.pendingGid,
      _plpHoverNeedsSecondProductImage: hoverMapped.needsSecondProductImage,
      _colorMatchedFromQuery: useVariantImage,
      image: cardMainImage,

      ss_available: hit.inventory_available ? "1" : "0",
      inventory_available: hit.inventory_available,

      template_suffix: hit.template_suffix || "",

      variant_title: hit.variant_title || "",
      variants_count: hit.variants_count,
      variants_min_price: hit.variants_min_price,
      variants_max_price: hit.variants_max_price,
      variants_compare_at_price_max: hit.variants_compare_at_price_max,
      variants: plpMapped.variantsEncoded,
      ss_swatches: plpMapped.ssSwatchesEncoded,
      variant_mfield_my_fields_color: plpMapped.variantColors,
      _parsedVariants: plpMapped.parsedVariants,
      _parsedSwatches: plpMapped.parsedSwatches,

      option1: hit.option1 || "",
      option2: hit.option2 || "",
      option3: hit.option3 || "",

      mfield_new_my_fields_brand_name: nm.brand_name || "",
      mfield_product_is_exclusive:
        pm.is_exclusive || hit.mfield_product_is_exclusive || "",
      mfield_new_my_fields_filter_color: nm.filter_color || "",
      mfield_new_my_fields_lead_time: nm.lead_time || "",
      mfield_new_my_fields_main_category: nm.main_category || "",
      mfield_new_my_fields_sub_category: nm.sub_category || "",
      mfield_new_my_fields_shipping_rate: nm.shipping_rate || "",
      mfield_new_my_fields_product_slice: nm.product_slice || "",

      mfield_custom_b2b_price: cm.b2b_price || "",
      variant_mfield_custom_b2b_price: cm.b2b_price || "",
      mfield_custom_media_gallery: cm.media_gallery || "",
      mfield_custom_cylindo_code: cm.cylindo_code || "",
      mfield_custom_sale_bucket: cm.sale_bucket || "",
      mfield_custom_custom_rug_flow: cm.custom_rug_flow || "",
      mfield_custom_rug_swatch: normalizeProductReferenceGid(
        cm.rug_swatch || hit.mfield_custom_rug_swatch
      ),
      mfield_custom_upsell_swatch: normalizeProductReferenceGid(
        cm.upsell_swatch || hit.mfield_custom_upsell_swatch
      ),
      mfield_custom_badge:
        cm.badge ||
        hit.mfield_custom_badge ||
        hit.badge ||
        "",
      mfield_custom_plp_image: cm.plp_image || "",
      mfield_custom_plp_hover_image: cm.plp_hover_image || "",
      mfield_custom_algolia_plp_main_image:
        cm.algolia_plp_main_image ||
        hit.mfield_custom_algolia_plp_main_image ||
        "",
      plpSliderImages: normalizeSliderImageUrls(
        cm.algolia_plp_slider_images ||
          hit.mfield_custom_algolia_plp_slider_images
      ),
      mfield_custom_swatch: cm.swatch || hit.mfield_custom_swatch || "",
      mfield_custom_algolia_plp_variants_4:
        cm.algolia_plp_variants_4 ||
        hit.mfield_custom_algolia_plp_variants_4 ||
        "",
      mfield_custom_length_rounded_ft_filter:
        cm.length_rounded_ft_filter || "",
      mfield_custom_width_rounded_ft_filter:
        cm.width_rounded_ft_filter || "",

      mfield_analytics_product_revenue_ytd:
        am.product_revenue_ytd || "",

      collection_id: hit.collection_ids || hit.collection_id || [],

      _rawHit: hit,
    };
  }

  function htmlEncodeJson(value) {
    try {
      return JSON.stringify(value)
        .replace(/&/g, "&amp;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    } catch (e) {
      return "[]";
    }
  }

  /**
   * Parse custom.media_gallery → MediaImage GIDs only (skip Video).
   * Fallback when Storefront product.images[1] is unavailable.
   */
  function parseMediaGalleryImageGids(raw) {
    if (!raw) return [];
    var list = raw;
    if (typeof raw === "string") {
      try {
        list = JSON.parse(raw);
      } catch (e) {
        list = String(raw)
          .split(",")
          .map(function (s) {
            return s.trim();
          })
          .filter(Boolean);
      }
    }
    if (!Array.isArray(list)) return [];
    return list.filter(function (entry) {
      return (
        typeof entry === "string" &&
        /^gid:\/\/shopify\/MediaImage\//.test(entry)
      );
    });
  }

  /**
   * SearchSpring ss_image_hover = Shopify product.images[1] (2nd product image).
   * Algolia product_image is featured/1st — do not use it as primary hover.
   * Prefetch in product-grid-utils resolves the real 2nd image by handle;
   * media_gallery[1] GID is a fallback source only.
   */
  function resolveSsImageHover(hit, cm) {
    var imageGids = parseMediaGalleryImageGids(
      cm.media_gallery || hit.mfield_custom_media_gallery
    );
    var secondGid = imageGids.length > 1 ? imageGids[1] : null;
    var handle = hit.handle || "";
    if (handle) {
      return {
        ss_image_hover: "",
        pendingGid: secondGid,
        needsSecondProductImage: true,
      };
    }
    if (secondGid) {
      return {
        ss_image_hover: "",
        pendingGid: secondGid,
        needsSecondProductImage: false,
      };
    }
    return {
      ss_image_hover: hit.product_image || "",
      pendingGid: null,
      needsSecondProductImage: false,
    };
  }

  function decodeHtmlEntitiesJson(raw) {
    if (typeof raw !== "string" || raw.indexOf("&quot;") === -1) return raw;
    try {
      return raw
        .replace(/&quot;/g, '"')
        .replace(/&amp;/g, "&")
        .replace(/&#39;/g, "'")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">");
    } catch (e) {
      return raw;
    }
  }

  function parseJsonArray(raw) {
    if (raw == null || raw === "") return null;
    raw = decodeHtmlEntitiesJson(raw);
    if (typeof raw === "string") {
      try {
        raw = JSON.parse(raw);
      } catch (e) {
        return null;
      }
    }
    return Array.isArray(raw) ? raw : null;
  }

  /** Shopify list metafield '["Natural"]' → 'Natural' for SS swatch match */
  function unwrapListText(value) {
    if (value == null || value === "") return "";
    if (Array.isArray(value)) {
      return value.length ? String(value[0]).trim() : "";
    }
    var str = String(value).trim();
    if (str.charAt(0) === "[") {
      try {
        var parsed = JSON.parse(str);
        if (Array.isArray(parsed) && parsed.length) return String(parsed[0]).trim();
      } catch (e) {
        /* keep str */
      }
    }
    return str;
  }

  function appendPlpChunk(merged, seen, raw) {
    var arr = parseJsonArray(raw);
    if (!arr || !arr.length) return false;
    for (var i = 0; i < arr.length; i++) {
      var item = arr[i];
      var vid = String(item.variant_id || item.id || "");
      if (vid && seen[vid]) continue;
      if (vid) seen[vid] = true;
      merged.push(item);
    }
    return true;
  }

  /**
   * Read Shopify metafield from sibling JSON.
   * Canonical (flat): item["new_my_fields.lead_time"]
   * Fallbacks: nested meta.new_my_fields.lead_time, legacy mfield_*
   */
  function metaVal(item, namespace, key, legacyFlatKey) {
    if (!item) return "";
    var shopifyKey = namespace + "." + key;
    if (item[shopifyKey] != null && item[shopifyKey] !== "") return item[shopifyKey];
    var meta = item.meta || {};
    var ns = meta[namespace] || {};
    if (ns[key] != null && ns[key] !== "") return ns[key];
    if (legacyFlatKey && item[legacyFlatKey] != null && item[legacyFlatKey] !== "") {
      return item[legacyFlatKey];
    }
    return "";
  }

  function normalizeGallery(raw) {
    if (raw == null || raw === "") return "";
    if (Array.isArray(raw)) {
      return raw
        .slice(0, 3)
        .map(function (s) {
          return String(s).trim();
        })
        .filter(Boolean)
        .join(",");
    }
    return String(raw)
      .split(",")
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean)
      .slice(0, 3)
      .join(",");
  }

  /**
   * Option names that are real color/fabric swatches — never Size / Ring Size / Title.
   */
  function isColorOptionName(name) {
    var n = String(name || "")
      .toLowerCase()
      .replace(/[_-]+/g, " ")
      .trim();
    return n === "color" || n === "colour" || n === "fabric";
  }

  function getOptionNames(hit) {
    var names = hit && hit.option_names;
    if (!Array.isArray(names) || !names.length) {
      var raw = hit && hit._rawHit;
      names = raw && raw.option_names;
    }
    return Array.isArray(names) ? names : [];
  }

  function productHasColorOption(hit) {
    var names = getOptionNames(hit);
    for (var i = 0; i < names.length; i++) {
      if (isColorOptionName(names[i])) return true;
    }
    return false;
  }

  /**
   * Variant value for a Color/Fabric option, by option_names position (option1/2/3).
   * Do not use Object.keys(hit.options) — key order is not option position.
   */
  function colorValueFromNamedOptions(hit, item) {
    var names = getOptionNames(hit);
    if (!names.length) return "";
    for (var i = 0; i < names.length && i < 3; i++) {
      if (isColorOptionName(names[i])) {
        var val =
          i === 0 ? item.option1 : i === 1 ? item.option2 : item.option3;
        return val ? String(val).trim() : "";
      }
    }
    return "";
  }

  /**
   * Read only custom.algolia_plp_variants_4 (slim PLP sibling variants).
   */
  function parsePlpVariants(hit, cm) {
    var merged = [];
    var seen = {};
    appendPlpChunk(
      merged,
      seen,
      cm.algolia_plp_variants_4 || hit.mfield_custom_algolia_plp_variants_4
    );
    return merged.length ? merged : null;
  }

  /**
   * Map algolia_plp_variants chunks → shapes product-grid-utils already understands.
   * Source of truth in JSON = Shopify metafield names under item.meta.*.
   */
  function mapPlpVariantsToSearchSpring(hit, cm) {
    var parsed = parsePlpVariants(hit, cm);
    var empty = {
      variantsEncoded: hit.variants || [],
      ssSwatchesEncoded: hit.ss_swatches || null,
      variantColors: hit.variant_mfield_my_fields_color || [],
      parsedVariants: null,
      parsedSwatches: null,
    };
    if (!parsed) return empty;

    var productId = String(hit.id || hit.product_id || "");
    var hasColorOption = productHasColorOption(hit);
    var colorSeen = {};
    var swatchByColor = {}; // Dedupe swatches by color, prefer available variants (O(1) lookup)
    var variantColors = [];
    var parsedVariants = [];
    var parsedSwatches = [];

    for (var i = 0; i < parsed.length; i++) {
      var item = parsed[i];
      var available = item.available !== false && item.available !== "false";
      var filterColor = unwrapListText(
        metaVal(
          item,
          "new_my_fields",
          "filter_color",
          "mfield_new_my_fields_filter_color"
        )
      );
      var legacyColor = unwrapListText(
        metaVal(item, "my_fields", "color", "mfield_my_fields_color")
      );
      var swatchImage =
        metaVal(item, "custom", "swatch", "mfield_custom_swatch") ||
        item.swatch_image ||
        "";
      var gallery = normalizeGallery(
        metaVal(item, "custom", "media_gallery", "mfield_custom_media_gallery")
      );
      // Size-only jewelry often has dirty my_fields.color / filter_color
      // (metal, gemstone spec, even care copy) that is NOT a Color option.
      var colorName = hasColorOption
        ? filterColor ||
          legacyColor ||
          colorValueFromNamedOptions(hit, item) ||
          ""
        : "";
      var title =
        item.title ||
        [item.option1, item.option2].filter(Boolean).join(" / ") ||
        "";
      var image = item.image || swatchImage || "";
      var variantId = String(item.variant_id || item.id || "");
      // Slim payload may omit url — build from product handle + variant_id
      var url = item.url || "";
      if (!url && variantId && hit.handle) {
        url = "/products/" + hit.handle + "?variant=" + variantId;
      }
      if (!variantId && url) {
        var vm = String(url).match(/[?&]variant=(\d+)/);
        if (vm) variantId = vm[1];
      }

      // PLP UI still uses SearchSpring field names — mapped here from meta.*
      parsedVariants.push({
        id: variantId,
        product_id: productId,
        title: title,
        option1: item.option1 || "",
        option2: item.option2 || "",
        option3: item.option3 || "",
        available: available,
        price: item.price || "",
        compare_at_price:
          item.compare_at_price ||
          item.variant_compare_at_price ||
          item.msrp ||
          "",
        image: image,
        mfield_custom_swatch: swatchImage,
        mfield_my_fields_color: legacyColor,
        mfield_new_my_fields_filter_color: filterColor,
        mfield_new_my_fields_lead_time: unwrapListText(
          metaVal(
            item,
            "new_my_fields",
            "lead_time",
            "mfield_new_my_fields_lead_time"
          )
        ),
        mfield_custom_b2b_price: metaVal(
          item,
          "custom",
          "b2b_price",
          "mfield_custom_b2b_price"
        ),
        mfield_custom_media_gallery: gallery,
        mfield_custom_sale_bucket: unwrapListText(
          metaVal(item, "custom", "sale_bucket", "mfield_custom_sale_bucket")
        ),
        mfield_custom_material_filter: unwrapListText(
          metaVal(
            item,
            "custom",
            "material_filter",
            "mfield_custom_material_filter"
          )
        ),
        mfield_custom_width_filter: unwrapListText(
          metaVal(item, "custom", "width_filter", "mfield_custom_width_filter")
        ),
        mfield_custom_gemstone_filter: unwrapListText(
          metaVal(
            item,
            "custom",
            "gemstone_filter",
            "mfield_custom_gemstone_filter"
          )
        ),
        mfield_custom_rug_size_bucket_filter: unwrapListText(
          metaVal(
            item,
            "custom",
            "rug_size_bucket_filter",
            "mfield_custom_rug_size_bucket_filter"
          )
        ),
        mfield_custom_variant_length_rounded_ft_filter: metaVal(
          item,
          "custom",
          "variant_length_rounded_ft_filter_",
          "mfield_custom_variant_length_rounded_ft_filter"
        ),
        mfield_custom_variant_width_rounded_ft_filter: metaVal(
          item,
          "custom",
          "variant_width_rounded_ft_filter_",
          "mfield_custom_variant_width_rounded_ft_filter"
        ),
        mfield_custom_jewelry_metal_filter: unwrapListText(
          metaVal(
            item,
            "custom",
            "jewelry_metal_filter",
            "mfield_custom_jewelry_metal_filter"
          )
        ),
        mfield_custom_jewelry_ring_type: unwrapListText(
          metaVal(
            item,
            "custom",
            "jewelry_ring_type",
            "mfield_custom_jewelry_ring_type"
          )
        ),
        mfield_custom_availability: metaVal(
          item,
          "custom",
          "availability",
          "mfield_custom_availability"
        ),
        mfield_custom_units_purchased: metaVal(
          item,
          "custom",
          "units_purchased",
          "mfield_custom_units_purchased"
        ),
        mfield_custom_added_to_cart: metaVal(
          item,
          "custom",
          "added_to_cart",
          "mfield_custom_added_to_cart"
        ),
        mfield_custom_item_viewed: metaVal(
          item,
          "custom",
          "item_viewed",
          "mfield_custom_item_viewed"
        ),
        mfield_custom_item_revenue: metaVal(
          item,
          "custom",
          "item_revenue",
          "mfield_custom_item_revenue"
        ),
        inventory_quantity: available ? 1 : 0,
        inventory_policy: "deny",
      });

      // Dedupe swatches by unique color only — never size / title / option1 fallbacks
      if (colorName) {
        var swatchColorKey = colorName.toLowerCase().trim();
        var existingSwatch = swatchByColor[swatchColorKey];
        // Keep first occurrence, or replace unavailable with available variant
        if (!existingSwatch || (!existingSwatch.available && available)) {
          swatchByColor[swatchColorKey] = {
            color: colorName,
            image: image,
            url: url,
            available: available,
          };
        }
      }

      if (colorName && !colorSeen[colorName]) {
        colorSeen[colorName] = true;
        variantColors.push(colorName);
      }
    }

    // Convert deduplicated color map to array for frontend consumption
    for (var key in swatchByColor) {
      if (swatchByColor.hasOwnProperty(key)) {
        parsedSwatches.push(swatchByColor[key]);
      }
    }

    return {
      variantsEncoded: [htmlEncodeJson(parsedVariants)],
      ssSwatchesEncoded: htmlEncodeJson(parsedSwatches),
      variantColors: variantColors,
      parsedVariants: parsedVariants,
      parsedSwatches: parsedSwatches,
    };
  }

  /**
   * Deduplicate variant hits into product-level results
   * Algolia returns one hit per variant, but frontend expects one result per product
   */
  function deduplicateVariantHits(normalizedHits) {
    var productMap = {};
    var productOrder = [];

    // Group hits by product_id
    normalizedHits.forEach(function (hit) {
      var productId = hit.id;
      if (!productId) return;

      if (!productMap[productId]) {
        productMap[productId] = {
          product: hit,
          variantHits: []
        };
        productOrder.push(productId);
      }

      // Prefer a hit that already has synced sibling data
      if (
        (!productMap[productId].product.ss_swatches && hit.ss_swatches) ||
        ((!productMap[productId].product.variants ||
          productMap[productId].product.variants.length === 0) &&
          hit.variants &&
          hit.variants.length > 0) ||
        (!productMap[productId].product.mfield_custom_badge &&
          hit.mfield_custom_badge)
      ) {
        productMap[productId].product = hit;
      }

      productMap[productId].variantHits.push(hit);
    });

    // Build deduplicated products
    var deduplicated = [];
    productOrder.forEach(function (productId) {
      var group = productMap[productId];
      var product = group.product;
      var variantHits = group.variantHits;

      // If variants field is already populated (from sync script), use it
      // Otherwise, build variants array from the variant hits
      if (!product.variants || product.variants.length === 0) {
        var variantsArray = variantHits.map(function (vHit) {
          var avail = !!vHit.inventory_available;
          return {
            id: vHit.variant_id,
            product_id: vHit.id,
            title: vHit.variant_title || "",
            sku: vHit.sku || "",
            available: avail,
            price: vHit.price || "",
            compare_at_price: vHit.msrp || "",
            image: vHit.image || "",
            option1: vHit.option1 || "",
            option2: vHit.option2 || "",
            option3: vHit.option3 || "",
            inventory_quantity: avail ? 1 : 0,
            inventory_policy: "deny",
          };
        });

        try {
          product.variants = [htmlEncodeJson(variantsArray)];
          product._parsedVariants = variantsArray;
        } catch (e) {
          console.error("[AlgoliaAdapter] Failed to build variants array:", e);
          product.variants = [];
        }
      }

      // Build ss_swatches if not already present — same real-color rule as mapPlpVariantsToSearchSpring
      if (!product.ss_swatches && variantHits.length > 0) {
        var swatches = [];
        var seenColors = {};
        
        variantHits.forEach(function (vHit) {
          var colorHit = vHit._rawHit || vHit;
          var color = "";
          if (productHasColorOption(colorHit)) {
            color =
              unwrapListText(
                metaVal(
                  vHit,
                  "new_my_fields",
                  "filter_color",
                  "mfield_new_my_fields_filter_color"
                )
              ) ||
              unwrapListText(
                metaVal(vHit, "my_fields", "color", "mfield_my_fields_color")
              ) ||
              colorValueFromNamedOptions(colorHit, vHit) ||
              "";
          }
          if (color && !seenColors[color]) {
            seenColors[color] = true;
            swatches.push({
              color: color,
              image: vHit.image || "",
              url: (vHit.handle ? "/products/" + vHit.handle : "") + "?variant=" + vHit.variant_id,
              available: vHit.inventory_available || false
            });
          }
        });

        if (swatches.length > 0) {
          try {
            product.ss_swatches = htmlEncodeJson(swatches);
            product._parsedSwatches = swatches;
          } catch (e) {
            console.error("[AlgoliaAdapter] Failed to build ss_swatches:", e);
          }
        }
      }

      // Clean up temporary field
      delete product._rawHit;

      deduplicated.push(product);
    });

    return deduplicated;
  }

  function normalizeFacets(algoliaFacets, algoliaFacetsStats) {
    if (!algoliaFacets) return [];

    var result = [];

    // Shopify option / id facets from facets:"*" — not SearchSpring PLP filters.
    // Leaving options.color in causes a second "Color" group (text checkboxes)
    // alongside meta.new_my_fields.filter_color (swatches only).
    function shouldSkipFacetAttr(algoliaField) {
      if (
        algoliaField === "collection_handles" ||
        algoliaField === "inventory_available" ||
        algoliaField === "inventory_quantity" ||
        algoliaField === "option_names" ||
        algoliaField === "collection_ids" ||
        algoliaField === "options" ||
        algoliaField.indexOf("options.") === 0 ||
        algoliaField === "tags" ||
        algoliaField === "vendor" ||
        algoliaField === "meta.custom.variant_width_rounded_ft_filter_" ||
        algoliaField === "meta.custom.variant_length_rounded_ft_filter_"
      ) {
        return true;
      }
      return false;
    }

    Object.keys(algoliaFacets).forEach(function (algoliaField) {
      if (shouldSkipFacetAttr(algoliaField)) return;

      var values = algoliaFacets[algoliaField];
      var ssField = ALGOLIA_TO_SS_FACET[algoliaField] || algoliaField;
      var label =
        FACET_LABELS[algoliaField] ||
        algoliaField
          .split(".")
          .pop()
          .replace(/_/g, " ")
          .replace(/\b\w/g, function (c) {
            return c.toUpperCase();
          });

      // Merge counts when index has both clean + JSON-encoded forms of same value
      var mergedCounts = {};
      Object.keys(values).forEach(function (rawVal) {
        var clean = unwrapFacetValue(rawVal) || String(rawVal);
        mergedCounts[clean] = (mergedCounts[clean] || 0) + (values[rawVal] || 0);
      });

      var facetValues = Object.keys(mergedCounts)
        .map(function (val) {
          return { value: val, label: val, count: mergedCounts[val], active: false };
        })
        .sort(function (a, b) {
          return b.count - a.count;
        });

      var facet = {
        field: ssField,
        label: label,
        type: isRangeField(ssField) ? "range" : "value",
        values: facetValues,
      };

      if (
        isRangeField(ssField) &&
        algoliaFacetsStats &&
        algoliaFacetsStats[algoliaField]
      ) {
        facet.range = {
          low: algoliaFacetsStats[algoliaField].min,
          high: algoliaFacetsStats[algoliaField].max,
        };
      }

      result.push(facet);
    });

    return result;
  }

  function parseSearchUrl(urlString) {
    var params;
    try {
      var url = new URL(urlString);
      params = url.searchParams;
    } catch (e) {
      var qi = urlString.indexOf("?");
      params =
        qi >= 0
          ? new URLSearchParams(urlString.slice(qi))
          : new URLSearchParams();
    }

    var query = params.get("q") || "";
    var collectionHandle =
      params.get("collection_handle") ||
      params.get("bgfilter.collection_handle") ||
      "";
    var ssPage = parseInt(params.get("page"), 10) || 1;
    var page = Math.max(0, ssPage - 1);
    var hitsPerPage = parseInt(params.get("resultsPerPage"), 10) || 24;

    var sortParam = "";
    params.forEach(function (val, key) {
      if (key.indexOf("sort.") === 0) {
        sortParam = key + "=" + val;
      }
    });

    var valueFilters = {};
    var rangeFilters = {};

    params.forEach(function (val, key) {
      if (key.indexOf("filter.") !== 0) return;
      if (key === "filter.ss_available") return;

      var rangeMatch = key.match(/^filter\.(.+?)\.(low|high)$/);
      if (rangeMatch) {
        var field = rangeMatch[1];
        var bound = rangeMatch[2];
        if (!rangeFilters[field]) rangeFilters[field] = {};
        rangeFilters[field][bound] = parseFloat(val);
        return;
      }

      var fld = key.replace(/^filter\./, "");
      if (!valueFilters[fld]) valueFilters[fld] = [];
      valueFilters[fld].push(val);
    });

    return {
      query: query,
      collectionHandle: collectionHandle,
      page: page,
      hitsPerPage: hitsPerPage,
      sortParam: sortParam,
      valueFilters: valueFilters,
      rangeFilters: rangeFilters,
    };
  }

  function buildAlgoliaFilters(collectionHandle, rangeFilters) {
    var parts = [];

    if (collectionHandle) {
      parts.push('collections:"' + collectionHandle + '"');
    }

    Object.keys(rangeFilters || {}).forEach(function (ssField) {
      var range = rangeFilters[ssField];
      var algField = SS_TO_ALGOLIA_FACET[ssField] || ssField;
      if (range.low !== undefined && !isNaN(range.low)) {
        parts.push(algField + " >= " + range.low);
      }
      if (range.high !== undefined && !isNaN(range.high)) {
        parts.push(algField + " <= " + range.high);
      }
    });

    return parts.join(" AND ");
  }

  function buildFacetFilters(valueFilters) {
    var facetFilters = [];

    Object.keys(valueFilters || {}).forEach(function (ssField) {
      var values = valueFilters[ssField];
      var algField = SS_TO_ALGOLIA_FACET[ssField] || ssField;
      var orGroup = [];
      (values || []).forEach(function (val) {
        facetValueMatchForms(val).forEach(function (form) {
          var entry = algField + ":" + form;
          if (orGroup.indexOf(entry) === -1) orGroup.push(entry);
        });
      });
      if (orGroup.length) facetFilters.push(orGroup);
    });

    return facetFilters;
  }

  window.AlgoliaAdapter = {
    client: null,
    indexName: "",

    init: function (config) {
      if (!config) {
        console.error(
          "[AlgoliaAdapter] Config is missing. Ensure window.algoliaConfig is set in theme.liquid."
        );
        return;
      }
      if (!config.appId) {
        console.error(
          "[AlgoliaAdapter] appId is missing in config. Check settings.algolia_app_id in theme settings."
        );
        return;
      }
      if (!config.apiKey) {
        console.error(
          "[AlgoliaAdapter] apiKey is missing in config. Check settings.algolia_search_api_key in theme settings."
        );
        return;
      }

      var algoliaLib =
        window["algoliasearch/lite"] || window.algoliasearch || null;
      var clientFn = algoliaLib
        ? algoliaLib.liteClient || algoliaLib
        : typeof algoliasearch !== "undefined"
          ? algoliasearch
          : null;
      if (!clientFn || typeof clientFn !== "function") {
        console.error(
          "[AlgoliaAdapter] algoliasearch not loaded. Ensure the CDN script is included before this file."
        );
        return;
      }

      this.client = clientFn(config.appId, config.apiKey);
      this.indexName = config.indexName || "shopify_prod_main_products";

      // Store Algolia config in localStorage for Shopify web pixel
      // Web pixel needs this to send conversion events
      try {
        var algoliaConfig = {
          app_id: config.appId,
          search_api_key: config.apiKey,
          index_name: this.indexName,
          user_token: this.getInsightsUserToken(),
        };
        localStorage.setItem("algolia_config", JSON.stringify(algoliaConfig));
      } catch (e) {
        // localStorage may be disabled - fail silently
      }
    },

    searchFromUrl: function (urlString) {
      var params = parseSearchUrl(urlString);
      return this.search(params);
    },

    search: function (params) {
      var query = params.query || "";
      var collectionHandle = params.collectionHandle || "";
      var page = params.page || 0;
      var hitsPerPage = params.hitsPerPage || 24;
      var sortParam = params.sortParam || "";
      var valueFilters = params.valueFilters || {};
      var rangeFilters = params.rangeFilters || {};

      if (!this.client) {
        console.error(
          "[AlgoliaAdapter] Client not initialized. Call init() first."
        );
        return Promise.resolve({
          results: [],
          facets: [],
          pagination: {
            totalResults: 0,
            totalPages: 0,
            currentPage: 1,
            perPage: hitsPerPage,
          },
          sorting: getDefaultSortOptions(),
        });
      }

      var targetIndex = getSortIndexName(sortParam, this.indexName);
      var filters = buildAlgoliaFilters(collectionHandle, rangeFilters);
      var facetFilters = buildFacetFilters(valueFilters);
      var userToken = this.getInsightsUserToken();

      // Determine page type for ruleContexts
      // Search page: has query but no collectionHandle (or is /search page)
      // Collection page: has collectionHandle (PLP/category pages)
      var pageType = "";
      if (query && !collectionHandle) {
        pageType = "search";
      } else if (collectionHandle) {
        pageType = "collection";
      }

      // distinct:true — Dashboard must also enable Distinct + attributeForDistinct=id
      // Do NOT send attributeForDistinct in the query (API returns 400).
      // clickAnalytics + userToken required so Insights can link PLP events to this query.
      var searchParams = {
        indexName: targetIndex,
        query: query,
        page: page,
        hitsPerPage: hitsPerPage,
        facets: ["*"],
        maxValuesPerFacet: 100,
        distinct: true,
        clickAnalytics: true,
        userToken: userToken,
      };

      // Add ruleContexts for merchandising rules (e.g., hide swatches on search)
      if (pageType) {
        searchParams.ruleContexts = [pageType];
      }

      if (filters) searchParams.filters = filters;
      if (facetFilters.length > 0) searchParams.facetFilters = facetFilters;

      // Disjunctive facets (SearchSpring parity): when a multi-select value filter
      // is active, Algolia's main query only returns that value in facets.
      // Companion queries omit that field so Color/Brand/etc. keep full option lists.
      var requests = [searchParams];
      var disjunctiveMeta = [];
      Object.keys(valueFilters).forEach(function (ssField) {
        var selected = valueFilters[ssField];
        if (!selected || !selected.length) return;

        var algField = SS_TO_ALGOLIA_FACET[ssField] || ssField;
        var others = {};
        Object.keys(valueFilters).forEach(function (f) {
          if (f !== ssField) others[f] = valueFilters[f];
        });

        var companion = {
          indexName: targetIndex,
          query: query,
          page: 0,
          hitsPerPage: 0,
          facets: [algField],
          maxValuesPerFacet: 100,
          distinct: true,
        };
        
        // Add same ruleContexts to companion queries
        if (pageType) {
          companion.ruleContexts = [pageType];
        }
        
        if (filters) companion.filters = filters;
        var companionFacetFilters = buildFacetFilters(others);
        if (companionFacetFilters.length > 0) {
          companion.facetFilters = companionFacetFilters;
        }

        disjunctiveMeta.push({ algField: algField });
        requests.push(companion);
      });

      return this.client
        .search({ requests: requests })
        .then(function (response) {
          var result = response.results[0];
          var perPage = result.hitsPerPage || hitsPerPage;
          var currentPage = (result.page || 0) + 1;

          var mergedFacets = Object.assign({}, result.facets || {});
          for (var i = 0; i < disjunctiveMeta.length; i++) {
            var companionResult = response.results[i + 1];
            var algField = disjunctiveMeta[i].algField;
            if (
              companionResult &&
              companionResult.facets &&
              companionResult.facets[algField]
            ) {
              mergedFacets[algField] = companionResult.facets[algField];
            }
          }

          var searchQuery = pageType === "search" ? query : "";
          var colorFilterValues =
            (valueFilters &&
              valueFilters.variant_mfield_new_my_fields_filter_color) ||
            (valueFilters && valueFilters.mfield_new_my_fields_filter_color) ||
            [];
          var selectedColorNorms = [];
          colorFilterValues.forEach(function (val) {
            collectColorLabels(val).forEach(function (label) {
              if (selectedColorNorms.indexOf(label) === -1) {
                selectedColorNorms.push(label);
              }
            });
          });
          var normalizedHits = (result.hits || []).map(function (hit) {
            return normalizeHit(hit, searchQuery, selectedColorNorms);
          });
          // Safety net if dashboard distinct is still off
          var results = deduplicateVariantHits(normalizedHits);
          var queryID = normalizeQueryID(result.queryID || "");

          var pageOffset = (result.page || 0) * perPage;
          results.forEach(function (product, i) {
            product._algoliaQueryID = queryID;
            product._algoliaIndex = targetIndex;
            product._algoliaObjectID = String(
              product.objectID || product.uid || ""
            );
            product._algoliaPosition = pageOffset + i + 1;
          });

          return {
            results: results,
            facets: normalizeFacets(mergedFacets, result.facets_stats),
            queryID: queryID,
            indexName: targetIndex,
            pagination: {
              totalResults: result.nbHits || 0,
              totalPages: result.nbPages || 0,
              currentPage: currentPage,
              perPage: perPage,
              resultsPerPage: perPage,
              begin: (result.page || 0) * perPage + 1,
              end: Math.min(currentPage * perPage, result.nbHits || 0),
            },
            sorting: getDefaultSortOptions(),
          };
        })
        .catch(function (error) {
          console.error("[AlgoliaAdapter] Search error:", error);
          return {
            results: [],
            facets: [],
            pagination: {
              totalResults: 0,
              totalPages: 0,
              currentPage: 1,
              perPage: hitsPerPage,
            },
            sorting: getDefaultSortOptions(),
          };
        });
    },

    getInsightsUserToken: function () {
      var key = "algolia_insights_user_token";
      try {
        var token = localStorage.getItem(key);
        if (!token) {
          token =
            (window.crypto &&
              window.crypto.randomUUID &&
              window.crypto.randomUUID()) ||
            "anonymous-" + Date.now() + "-" + Math.random().toString(36).slice(2);
          localStorage.setItem(key, token);
        }
        return token;
      } catch (e) {
        return "anonymous-" + Date.now();
      }
    },

    /**
     * Send Algolia Insights events (PLP click / view).
     * Uses search API key + Insights endpoint (same pattern as header search).
     */
    sendInsightsEvents: function (events) {
      var config = window.algoliaConfig || {};
      if (
        !config.appId ||
        !config.apiKey ||
        !events ||
        !events.length
      ) {
        return Promise.resolve();
      }

      var sanitizedEvents = events.map(function (event) {
        if (!event || event.queryID == null || event.queryID === "") {
          return event;
        }
        var cleaned = normalizeQueryID(event.queryID);
        if (cleaned === event.queryID) return event;
        return Object.assign({}, event, { queryID: cleaned });
      });

      return fetch("https://insights.algolia.io/1/events", {
        method: "POST",
        keepalive: true,
        headers: {
          "Content-Type": "application/json",
          "X-Algolia-Application-Id": config.appId,
          "X-Algolia-API-Key": config.apiKey,
        },
        body: JSON.stringify({ events: sanitizedEvents }),
      }).then(function (response) {
        if (!response.ok) {
          return response.text().then(function (text) {
            console.error("[AlgoliaAdapter] Insights error:", text);
          });
        }
      }).catch(function (err) {
        console.error("[AlgoliaAdapter] Insights request failed:", err);
      });
    },

    trackPlpClick: function (opts) {
      opts = opts || {};
      var objectID = opts.objectID && String(opts.objectID);
      var queryID = opts.queryID && normalizeQueryID(opts.queryID);
      var position = Number(opts.position);
      var index =
        opts.indexName ||
        (window.algoliaConfig && window.algoliaConfig.indexName) ||
        this.indexName;
      if (!objectID || !queryID || !index || !position || position < 1) {
        return Promise.resolve();
      }

      try {
        sessionStorage.setItem(
          "algolia_plp_queryID",
          queryID
        );
        sessionStorage.setItem(
          "algolia_plp_objectID_" + objectID,
          queryID
        );
      } catch (e) {}

      return this.sendInsightsEvents([
        {
          eventType: "click",
          eventName: "PLP Product Clicked",
          index: index,
          userToken: this.getInsightsUserToken(),
          queryID: queryID,
          objectIDs: [objectID],
          positions: [position],
        },
      ]);
    },

    trackPlpViews: function (opts) {
      opts = opts || {};
      var objectIDs = (opts.objectIDs || [])
        .map(function (id) {
          return String(id || "");
        })
        .filter(Boolean);
      var queryID = opts.queryID && normalizeQueryID(opts.queryID);
      var index =
        opts.indexName ||
        (window.algoliaConfig && window.algoliaConfig.indexName) ||
        this.indexName;
      if (!objectIDs.length || !queryID || !index) {
        return Promise.resolve();
      }

      var userToken = this.getInsightsUserToken();
      var chunks = [];
      for (var i = 0; i < objectIDs.length; i += 20) {
        chunks.push(objectIDs.slice(i, i + 20));
      }
      var self = this;
      return chunks.reduce(function (chain, chunk) {
        return chain.then(function () {
          return self.sendInsightsEvents([
            {
              eventType: "view",
              eventName: "PLP Hits Viewed",
              index: index,
              userToken: userToken,
              queryID: queryID,
              objectIDs: chunk,
            },
          ]);
        });
      }, Promise.resolve());
    },

    trackSearchAttribution: function (opts) {
      opts = opts || {};
      var queryID = opts.queryID && normalizeQueryID(opts.queryID);
      var variantID = opts.variantID && String(opts.variantID);
      var productID = opts.productID && String(opts.productID);
      var index =
        opts.indexName ||
        (window.algoliaConfig && window.algoliaConfig.indexName) ||
        this.indexName;

      if (!queryID || !variantID || !productID || !index) {
        return;
      }

      try {
        var clickData = {
          eventName: "Added to cart",
          index: index,
          queryID: queryID,
          objectIDs: [variantID],
          productId: productID,
        };

        var localStorageKey = "algolia_analytics_clicked_objects";
        var previousClickItems = JSON.parse(
          localStorage.getItem(localStorageKey) || "[]"
        );
        previousClickItems.push(clickData);
        localStorage.setItem(
          localStorageKey,
          JSON.stringify(previousClickItems)
        );
      } catch (e) {
        // localStorage may be disabled - fail silently
      }
    },
  };
})();
